import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { formatAmount } from "../../../utils/format";
import { axios_instance } from "../../../api/axios_instance";
import { ENABLELINKLOAN } from "../../../utils/constant";
import { modalEventListener } from "../../../utils/ModalEventListener";

const ControlReasonsModal = ({
  caseDetails,
  controlsystem,
  closeControlReasonsModal,
}) => {
  const ref = useRef();

  const fetchDetails = useCallback(async () => {
    try {
      let bureaudetails = await axios_instance({
        url: "/dts/bureauLinkLoanDetails",
        method: "POST",
        data: {
          loan_id: caseDetails.lead_id,
          is_experian_hit: caseDetails.is_experian_hit,
          is_crif_hit: caseDetails.is_crif_hit,
        },
      });

      bureaudetails = bureaudetails.data.result.message;
      const linkAccount =
        bureaudetails.data && bureaudetails.data.linkLoans
          ? bureaudetails.data.linkLoans
          : [];
      const ret = [];

      if (linkAccount.length) {
        linkAccount.forEach((account) => {
          const financier_map_id = caseDetails.financier_map_id;
          if (
            account.CreditGuarantorId === financier_map_id &&
            financier_map_id > 0
          ) {
            if (account.loans.length) {
              account.loans.forEach((loan) => {
                let temp = { loan_type: loan.AccountType };
                temp.amount = loan.DisbursedAmount;
                temp.status = "Active";
                temp.bank_name = caseDetails.financier_name;
                ret.push(temp);
              });
            }
          }
        });
      }
      setBureauDetails((prevState) => ({
        ...prevState,
        bureauDetails: ret,
      }));
    } catch (error) {}
  }, [
    caseDetails.financier_map_id,
    caseDetails.financier_name,
    caseDetails.is_crif_hit,
    caseDetails.is_experian_hit,
    caseDetails.lead_id,
  ]);

  useEffect(() => {
    if (caseDetails.link_loan_cnt > 0 && ENABLELINKLOAN) {
      fetchDetails();
    }
    modalEventListener(ref, closeControlReasonsModal);
    return () => {
      document.body.style.overflow = "scroll";
    };
  }, [caseDetails, closeControlReasonsModal, fetchDetails]);

  const [bureauDetails, setBureauDetails] = useState([]);

  return ReactDOM.createPortal(
    <>
      <div className="modal-wrapper">
        <div className="controlreasons-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeControlReasonsModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title" id="">
              {`${controlsystem.type
                .charAt(0)
                .toUpperCase()}${controlsystem.type.slice(1)} Reasons`}
            </h4>
          </div>
          <div className="modal-body clearfix">
            <ul className="list-reasons">
              {controlsystem.reasons &&
                controlsystem.reasons.length > 0 &&
                controlsystem.reasons.map((reason, index) => {
                  return (
                    <li className="reason" key={index}>
                      {reason}
                    </li>
                  );
                })}
            </ul>
            {controlsystem.link_loan_active && (
              <>
                <div
                  id="bureau_details_loader"
                  style={{
                    display: "none",
                    zIndex: "1120",
                    position: "fixed",
                    width: "100%",
                    height: "100%",
                    top: "0",
                  }}
                >
                  <img
                    src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                    style={{
                      position: "absolute",
                      top: "56%",
                      left: "33%",
                    }}
                    alt=""
                  />
                </div>
                <div className="col-md-12">
                  <div className="table-responsive">
                    <h4>Bureau Details</h4>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Loan Type</th>
                          <th>
                            Amount(<span className="fa fa-inr"></span>)
                          </th>
                          <th>Status</th>
                          <th>Bank Name</th>
                        </tr>
                      </thead>
                      <tbody id="bureau_details">
                        {bureauDetails && bureauDetails.length ? (
                          bureauDetails.forEach((detail) => {
                            <tr>
                              <td width="25%">${detail.loan_type}</td>
                              <td width="20%">
                                <span class="fa fa-inr"></span>$
                                {formatAmount(detail.amount)}
                              </td>
                              <td width="15%">${detail.status}</td>
                              <td width="40%">${detail.bank_name}</td>
                            </tr>;
                          })
                        ) : (
                          <tr>
                            <td colSpan="4">No Record Found!</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20"
              data-dismiss="modal"
              onClick={closeControlReasonsModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ControlReasonsModal;
